module.exports = "/images/db8d95dc6d83f6ad3fad461ca42e2f82.png";